/**
 * Environment detection utilities for the viz package
 */

/**
 * Checks if the current environment is local development
 */
export const isLocalDevelopment = (): boolean => {
	if (typeof window === 'undefined') {
		// Server-side rendering or Node.js environment
		return process.env.NODE_ENV === 'development';
	}

	const host = window.location.host;
	return host.includes('localhost') || host.includes('127.0.0.1') || host.includes('0.0.0.0');
};

/**
 * Checks if the current environment is staging
 */
export const isStaging = (): boolean => {
	if (typeof window === 'undefined') {
		return false;
	}

	const host = window.location.host;
	return (
		host.includes('.stg.atlassian') ||
		host.includes('.stg-east.frontend.public.atl-paas.net') ||
		host.includes('jira-dev.com') ||
		host.includes('trellis.coffee')
	);
};

/**
 * Checks if the current environment is production
 */
export const isProduction = (): boolean => {
	return !isLocalDevelopment() && !isStaging();
};
